(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  Settings & State                                                   */
  /* ------------------------------------------------------------------ */
  var settingsEl = document.getElementById('quoteBuilderSettings');
  if (!settingsEl) return;
  var SETTINGS = JSON.parse(settingsEl.textContent);

  /* Fixed product catalog */
  var CATALOG = {
    'rachel-basic':  { title: 'RACHEL Basic (500GB)',  price: 50000, shipVariantId: 41906279743577 },
    'rachel-plus':   { title: 'RACHEL Plus (1TB)',     price: 70000, shipVariantId: 41906279743577 },
    'rachel-ultra':  { title: 'RACHEL Ultra (2TB)',    price: 80000, shipVariantId: 41906279743577 },
    'rachel-ai':     { title: 'RACHEL AI (RACHEL 6)',  price: 75000, shipVariantId: 43627774345305 },
    'warranty':      { title: 'Extended Warranty (2-Year)', price: 14900, shipVariantId: 45429005199 },
    'chromebooks':   { title: 'Refurbished Chromebook 10-Pack', price: 75000, shipVariantId: 40293758173273 },
    'laptop-kit-10': { title: 'RACHEL + 10 Laptops Travel Kit (Small)',  price: 550000, shipVariantId: 42047387762777 },
    'laptop-kit-20': { title: 'RACHEL + 20 Laptops Travel Kit (Medium)', price: 800000, shipVariantId: 42047387795545 },
    'laptop-kit-30': { title: 'RACHEL + 30 Laptops Travel Kit (Large)',  price: 1050000, shipVariantId: 42047387828313 }
  };

  var state = {
    shippingRate: null,
    logoDataUrl: null,
    logoWidth: 0,
    logoHeight: 0,
    language: 'English',
    invoiceMode: new URLSearchParams(window.location.search).has('invoice'),
    cartWeightLbs: 0
  };

  /* ------------------------------------------------------------------ */
  /*  DOM refs                                                           */
  /* ------------------------------------------------------------------ */
  var els = {
    itemsSection:     document.getElementById('quoteItemsSection'),
    itemsBody:        document.getElementById('quoteItemsBody'),
    itemsFoot:        document.getElementById('quoteItemsFoot'),
    subtotal:         document.getElementById('quoteSubtotal'),
    shipCountry:      document.getElementById('quoteShipCountry'),
    shipProvince:     document.getElementById('quoteShipProvince'),
    shipZip:          document.getElementById('quoteShipZip'),
    getShippingBtn:   document.getElementById('quoteGetShipping'),
    shippingResults:  document.getElementById('quoteShippingResults'),
    shippingLoading:  document.querySelector('.quote-builder__shipping-loading'),
    shippingRates:    document.getElementById('quoteShippingRates'),
    summary:          document.getElementById('quoteSummary'),
    summarySubtotal:  document.getElementById('quoteSummarySubtotal'),
    summaryShipRow:   document.getElementById('quoteSummaryShippingRow'),
    summaryShipName:  document.getElementById('quoteSummaryShippingName'),
    summaryShipping:  document.getElementById('quoteSummaryShipping'),
    summaryTotal:     document.getElementById('quoteSummaryTotal'),
    downloadBtn:      document.getElementById('quoteDownloadPdf'),
    custName:         document.getElementById('quoteCustName'),
    custEmail:        document.getElementById('quoteCustEmail'),
    custPhone:        document.getElementById('quoteCustPhone'),
    custAddress:      document.getElementById('quoteCustAddress'),
    custCountry:      document.getElementById('quoteCustCountry'),
    notes:            document.getElementById('quoteNotes')
  };

  /* ------------------------------------------------------------------ */
  /*  Helpers                                                            */
  /* ------------------------------------------------------------------ */
  function money(cents) {
    var val = cents / 100;
    return '$' + val.toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function generateFallbackQuoteNumber() {
    var now = new Date();
    return 'Q-' + now.getFullYear() +
      String(now.getMonth() + 1).padStart(2, '0') +
      String(now.getDate()).padStart(2, '0') + '-' +
      String(now.getHours()).padStart(2, '0') +
      String(now.getMinutes()).padStart(2, '0') +
      String(now.getSeconds()).padStart(2, '0');
  }

  /* ------------------------------------------------------------------ */
  /*  Catalog → Items                                                    */
  /* ------------------------------------------------------------------ */
  function getItems() {
    var items = [];
    document.querySelectorAll('.quote-catalog__qty').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      if (qty > 0) {
        var key = input.getAttribute('data-product-key');
        var product = CATALOG[key];
        if (product) {
          items.push({ key: key, title: product.title, price: product.price, qty: qty, shipVariantId: product.shipVariantId });
        }
      }
    });
    return items;
  }

  function getSubtotal() {
    return getItems().reduce(function (sum, i) { return sum + i.price * i.qty; }, 0);
  }

  function renderItems() {
    var items = getItems();
    var tbody = els.itemsBody;
    tbody.innerHTML = '';

    clearShippingRate();

    if (!items.length) {
      els.itemsSection.hidden = true;
      els.summary.hidden = true;
      els.downloadBtn.disabled = true;
      return;
    }

    els.itemsSection.hidden = false;

    items.forEach(function (item) {
      var tr = document.createElement('tr');
      tr.innerHTML =
        '<td>' + escapeHtml(item.title) + '</td>' +
        '<td>' + money(item.price) + '</td>' +
        '<td style="text-align:center">' + item.qty + '</td>' +
        '<td>' + money(item.price * item.qty) + '</td>';
      tbody.appendChild(tr);
    });

    var subtotal = getSubtotal();
    els.subtotal.textContent = money(subtotal);

    els.summary.hidden = false;
    els.summarySubtotal.textContent = money(subtotal);
    var total = subtotal + (state.shippingRate ? Math.round(parseFloat(state.shippingRate.price) * 100) : 0);
    els.summaryTotal.textContent = money(total);
    updateDownloadButtonState();
  }

  function updateDownloadButtonState() {
    if (!getItems().length) {
      els.downloadBtn.disabled = true;
      return;
    }
    if (!state.shippingRate) {
      els.downloadBtn.disabled = true;
      els.downloadBtn.textContent = 'Get a shipping quote first';
      return;
    }
    els.downloadBtn.disabled = false;
    els.downloadBtn.textContent = state.invoiceMode ? 'Download & Email Invoice' : 'Download & Email Quote';
  }

  function clearShippingRate() {
    if (!state.shippingRate) return;
    state.shippingRate = null;
    els.summaryShipRow.hidden = true;
    els.shippingResults.hidden = true;
    els.shippingRates.innerHTML = '';
  }

  /* ------------------------------------------------------------------ */
  /*  Shipping Rates                                                     */
  /* ------------------------------------------------------------------ */
  /* Default postal codes for countries that don't use zip/postal codes. */
  var DEFAULT_ZIP_BY_COUNTRY = {
    GH: 'GA-001-0001', KE: '00100', NG: '100001', TZ: '11101', UG: '256',
    RW: '0000', ZA: '0001', ET: '1000', CI: '00225', SN: '10000',
    ML: '99999', MZ: '0001', ZM: '10101', MW: '0000', BF: '06',
    NE: '0000', TD: '0000', CM: '0000', SL: '00232', LR: '1000',
    GM: '0000', HT: 'HT6110', PG: '111', TL: '0000', MM: '11181',
    PA: '0816', HN: '11101', NI: '11001', GY: '00000', SR: '00000',
    BZ: '0000', JM: 'JMAAW01', TT: '000000', AO: '0000', BI: '0000',
    DJ: '0000', ER: '0000', GN: '0000', GW: '0000', KM: '0000',
    LS: '0000', LY: '0000', MR: '0000', NA: '0000', SC: '0000',
    SO: '0000', SS: '0000', SD: '0000', SZ: '0000', TG: '0000', ZW: '0000'
  };

  /* Default province/state for countries where Shopify requires one */
  var DEFAULT_PROVINCE_BY_COUNTRY = {
    PA: 'PA-8', CO: 'CO-DC', MX: 'DF', AR: 'C', CL: 'RM', PE: 'LMA',
    IE: 'D', IN: 'DL', AU: 'NSW', JP: 'JP-13', KR: 'KR-11', TH: 'TH-10',
    MY: 'MY-14', PH: 'PH-00', EG: 'C', ZA: 'GT', NG: 'LA', KE: 'KE-30',
    GH: 'AA', BR: 'SP', IT: 'RM', ES: 'M', PT: 'PT-11', RO: 'B', ID: 'JK',
    NZ: 'AUK', AE: 'DU', SA: 'RI', HK: 'HK', CN: 'SH', RU: 'MOW',
    GT: 'GT-GU', SV: 'SV-SS', HN: 'HN-FM', NI: 'NI-MN', CR: 'SJ'
  };

  /* Clear zip placeholder when a no-zip country is selected */
  els.shipCountry.addEventListener('change', function () {
    var code = els.shipCountry.value;
    if (DEFAULT_ZIP_BY_COUNTRY[code]) {
      els.shipZip.value = '';
      els.shipZip.placeholder = 'Not required for ' + els.shipCountry.options[els.shipCountry.selectedIndex].text;
    } else {
      els.shipZip.placeholder = 'e.g. 90210';
    }
  });

  function fetchShippingRates() {
    var items = getItems();
    if (!items.length) {
      alert('Please add at least one product before fetching shipping rates.');
      return;
    }

    var zip = els.shipZip.value.trim();
    var country = els.shipCountry.value;
    var province = els.shipProvince.value.trim();

    /* For countries without postal codes, allow empty zip */
    var noZipCountry = !!DEFAULT_ZIP_BY_COUNTRY[country];

    if (!country) {
      alert('Please select a country.');
      return;
    }
    if (!zip && !noZipCountry) {
      alert('Please enter a postal/ZIP code.');
      return;
    }

    els.shippingResults.hidden = false;
    els.shippingLoading.hidden = false;
    els.shippingRates.innerHTML = '';
    els.getShippingBtn.disabled = true;

    // Build cart items from catalog shipVariantIds (merging dupes)
    var variantMap = {};
    items.forEach(function (item) {
      var vid = item.shipVariantId;
      if (variantMap[vid]) {
        variantMap[vid] += item.qty;
      } else {
        variantMap[vid] = item.qty;
      }
    });
    var cartItems = Object.keys(variantMap).map(function (vid) {
      return { id: parseInt(vid, 10), quantity: variantMap[vid] };
    });

    var originalCart = null;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        originalCart = cart;
        return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
      })
      .then(function (addRes) {
        return addRes.json().then(function (addData) {
          console.log('[Quote Shipping] cart/add response:', addRes.status, addData);
          return addData;
        });
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.cartWeightLbs = (cart.total_weight || 0) / 453.59237;
        console.log('[Quote Shipping] Cart weight:', state.cartWeightLbs.toFixed(1), 'lb');

        var effectiveProvince = province || DEFAULT_PROVINCE_BY_COUNTRY[country] || '';
        var effectiveZip = zip || DEFAULT_ZIP_BY_COUNTRY[country] || '00000';
        var params = 'shipping_address[zip]=' + encodeURIComponent(effectiveZip) +
                     '&shipping_address[country]=' + encodeURIComponent(country) +
                     '&shipping_address[province]=' + encodeURIComponent(effectiveProvince);
        console.log('[Quote Shipping] Fetching rates: country=' + country + ' zip=' + effectiveZip + ' province=' + effectiveProvince);
        console.log('[Quote Shipping] URL: /cart/shipping_rates.json?' + params);
        return fetch('/cart/shipping_rates.json?' + params);
      })
      .then(function (r) {
        console.log('[Quote Shipping] Response status:', r.status);
        if (!r.ok) {
          return r.text().then(function (body) {
            console.error('[Quote Shipping] Error body:', body);
            // If zip validation failed, retry without zip
            try {
              var errObj = JSON.parse(body);
              if (errObj.zip) {
                console.log('[Quote Shipping] Retrying without zip...');
                var effectiveProvince2 = province || DEFAULT_PROVINCE_BY_COUNTRY[country] || '';
                var retryParams = 'shipping_address[zip]=' +
                  '&shipping_address[country]=' + encodeURIComponent(country) +
                  '&shipping_address[province]=' + encodeURIComponent(effectiveProvince2);
                return fetch('/cart/shipping_rates.json?' + retryParams)
                  .then(function (r2) {
                    console.log('[Quote Shipping] Retry status:', r2.status);
                    if (!r2.ok) {
                      return r2.text().then(function (b2) {
                        console.error('[Quote Shipping] Retry error:', b2);
                        renderShippingRates([]);
                        return null;
                      });
                    }
                    return r2.json();
                  });
              }
            } catch (e) { /* not JSON */ }
            renderShippingRates([]);
            return null;
          });
        }
        return r.json();
      })
      .then(function (data) {
        if (data === null) return; // Already handled in fallback
        console.log('[Quote Shipping] Rates received:', data);
        var rates = data.shipping_rates || [];
        renderShippingRates(rates);
      })
      .catch(function (err) {
        console.error('[Quote Shipping] Fetch error:', err);
        // Network error or other failure - show fallback estimate
        renderShippingRates([]);
      })
      .finally(function () {
        els.shippingLoading.hidden = true;
        els.getShippingBtn.disabled = false;
        restoreCart(originalCart);
      });
  }

  function restoreCart(originalCart) {
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        if (originalCart && originalCart.items && originalCart.items.length) {
          var items = originalCart.items.map(function (i) {
            return { id: i.variant_id, quantity: i.quantity };
          });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        }
      })
      .catch(function () { /* silently fail on cart restore */ });
  }

  /* Flat freight option for heavy shipments, offered regardless of destination. */
  function getFreightOption() {
    if (state.cartWeightLbs > 250) {
      return { name: 'Freight Shipping (250+ lb)', price: '2500.00' };
    }
    if (state.cartWeightLbs > 100) {
      return { name: 'Freight Shipping (100–250 lb)', price: '1000.00' };
    }
    return null;
  }

  function renderShippingRates(rates) {
    var freight = getFreightOption();

    if (!rates.length) {
      var totalUnits = getItems().reduce(function (w, i) { return w + i.qty; }, 0);
      var baseShipping = 200 + Math.max(0, totalUnits - 1) * 50;
      var estimates = [
        { name: 'International Shipping (est. 2–6 weeks)', price: baseShipping.toFixed(2) }
      ];
      if (freight) estimates.push(freight);
      var html = '<p class="quote-builder__shipping-note" style="color:#D97706;font-weight:600;margin-bottom:1rem;">' +
        '⚠ Exact rates unavailable for this destination. Estimates shown below — final shipping will be confirmed when the order is placed.</p>' +
        '<div class="quote-builder__rates-list">';
      estimates.forEach(function (rate, idx) {
        var checked = idx === 0 ? 'checked' : '';
        html += '<label class="quote-builder__rate-option">' +
          '<input type="radio" name="quoteShippingRate" value="' + idx + '" ' + checked +
          ' data-name="' + escapeHtml(rate.name) + '"' +
          ' data-price="' + escapeHtml(rate.price) + '">' +
          '<span class="quote-builder__rate-name">' + escapeHtml(rate.name) + '</span>' +
          '<span class="quote-builder__rate-price">~$' + parseFloat(rate.price).toFixed(2) + '</span>' +
          '</label>';
      });
      html += '</div>';
      els.shippingRates.innerHTML = html;
      selectShippingRate(estimates[0].name, estimates[0].price);
      els.shippingRates.querySelectorAll('input[name="quoteShippingRate"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          selectShippingRate(radio.getAttribute('data-name'), radio.getAttribute('data-price'));
        });
      });
      return;
    }

    var displayRates = freight ? rates.concat([freight]) : rates;

    var html = '<div class="quote-builder__rates-list">';
    displayRates.forEach(function (rate, idx) {
      var checked = idx === 0 ? 'checked' : '';
      html += '<label class="quote-builder__rate-option">' +
        '<input type="radio" name="quoteShippingRate" value="' + idx + '" ' + checked +
        ' data-name="' + escapeHtml(rate.name) + '"' +
        ' data-price="' + escapeHtml(String(rate.price)) + '">' +
        '<span class="quote-builder__rate-name">' + escapeHtml(rate.name) + '</span>' +
        '<span class="quote-builder__rate-price">$' + parseFloat(rate.price).toFixed(2) + '</span>' +
        '</label>';
    });
    html += '</div>';
    els.shippingRates.innerHTML = html;

    if (rates.length) {
      selectShippingRate(rates[0].name, rates[0].price);
    }

    els.shippingRates.querySelectorAll('input[name="quoteShippingRate"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        selectShippingRate(radio.getAttribute('data-name'), radio.getAttribute('data-price'));
      });
    });
  }

  function selectShippingRate(name, price) {
    state.shippingRate = { name: name, price: price };
    els.summaryShipRow.hidden = false;
    els.summaryShipName.textContent = name;
    els.summaryShipping.textContent = '$' + parseFloat(price).toFixed(2);

    var subtotal = getSubtotal();
    var total = subtotal + Math.round(parseFloat(price) * 100);
    els.summaryTotal.textContent = money(total);
    updateDownloadButtonState();
  }

  /* ------------------------------------------------------------------ */
  /*  PDF Generation                                                     */
  /* ------------------------------------------------------------------ */
  function generatePDF() {
    if (!getItems().length) return;
    if (!state.shippingRate) {
      alert('Please get a shipping quote before generating the ' + (state.invoiceMode ? 'invoice' : 'quote') + '.');
      return;
    }

    var docType = state.invoiceMode ? 'invoice' : 'quote';
    els.downloadBtn.disabled = true;
    els.downloadBtn.textContent = 'Generating ' + docType + '...';

    fetch('https://datapost.site/api/quote-number')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success) throw new Error('Server error');
        var num = data.number;
        if (state.invoiceMode) num = num.replace(/^Q-/, 'INV-');
        buildAndSendPDF(num);
      })
      .catch(function () {
        var num = generateFallbackQuoteNumber();
        if (state.invoiceMode) num = num.replace(/^Q-/, 'INV-');
        buildAndSendPDF(num);
      });
  }

  function buildAndSendPDF(quoteNum) {
    var isInvoice = state.invoiceMode;
    var docLabel = isInvoice ? 'INVOICE' : 'QUOTE';
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF('p', 'mm', 'letter');
    var pageWidth = doc.internal.pageSize.getWidth();
    var margin = 15;
    var y = 0;
    var today = new Date();
    var dateStr = today.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    var validDate = new Date(today);
    validDate.setDate(validDate.getDate() + (SETTINGS.quoteValidDays || 30));
    var validStr = validDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    // -- Branded header bar --
    var headerH = 22;
    doc.setFillColor(26, 59, 74);
    doc.rect(0, 0, pageWidth, headerH, 'F');

    if (state.logoDataUrl && state.logoWidth && state.logoHeight) {
      var logoH = 14;
      var logoW = logoH * (state.logoWidth / state.logoHeight);
      doc.addImage(state.logoDataUrl, 'PNG', margin, 4, logoW, logoH);
    }

    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.text(docLabel, pageWidth - margin, 14, { align: 'right' });
    doc.setTextColor(0, 0, 0);

    y = headerH + 6;

    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
    doc.text(SETTINGS.companyName || 'Quote', margin, y + 4);
    y += 9;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    if (SETTINGS.companyAddress) {
      var addrLines = SETTINGS.companyAddress.split('\n');
      addrLines.forEach(function (line) {
        doc.text(line, margin, y);
        y += 4;
      });
    }
    if (SETTINGS.companyPhone) {
      doc.text('Phone: ' + SETTINGS.companyPhone, margin, y);
      y += 4;
    }
    if (SETTINGS.companyEmail) {
      doc.text('Email: ' + SETTINGS.companyEmail, margin, y);
      y += 4;
    }

    var rightX = pageWidth - margin;
    var infoY = headerH + 10;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text((isInvoice ? 'Invoice' : 'Quote') + ' #: ' + quoteNum, rightX, infoY, { align: 'right' });
    doc.text('Date: ' + dateStr, rightX, infoY + 5, { align: 'right' });
    if (isInvoice) {
      doc.text('Payment Due: Upon Receipt', rightX, infoY + 10, { align: 'right' });
    } else {
      doc.text('Valid Until: ' + validStr, rightX, infoY + 10, { align: 'right' });
    }

    y = Math.max(y, infoY + 14) + 4;

    doc.setDrawColor(200, 200, 200);
    doc.line(margin, y, pageWidth - margin, y);
    y += 8;

    var custName = els.custName.value.trim();
    var custEmail = els.custEmail.value.trim();
    var custPhone = els.custPhone.value.trim();
    var custAddress = els.custAddress.value.trim();
    var custCountry = els.custCountry ? els.custCountry.value.trim() : '';

    if (custName || custEmail || custPhone || custAddress) {
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text(isInvoice ? 'Bill To:' : 'Quote For:', margin, y);
      y += 5;
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      if (custName) { doc.text(custName, margin, y); y += 4; }
      if (custEmail) { doc.text(custEmail, margin, y); y += 4; }
      if (custPhone) { doc.text(custPhone, margin, y); y += 4; }
      if (custCountry) { doc.text('Deployment Country: ' + custCountry, margin, y); y += 4; }
      if (custAddress) {
        custAddress.split('\n').forEach(function (line) {
          doc.text(line, margin, y); y += 4;
        });
      }
      y += 4;
    }

    // -- Language --
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('Primary Language: ', margin, y);
    doc.setFont('helvetica', 'normal');
    doc.text(state.language, margin + doc.getTextWidth('Primary Language: '), y);
    y += 6;

    // -- Items Table --
    var tableData = getItems().map(function (item) {
      return [
        item.title,
        item.qty.toString(),
        money(item.price),
        money(item.price * item.qty)
      ];
    });

    doc.autoTable({
      startY: y,
      margin: { left: margin, right: margin },
      head: [['Product', 'Qty', 'Unit Price', 'Line Total']],
      body: tableData,
      theme: 'striped',
      headStyles: {
        fillColor: [26, 115, 232],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 9
      },
      bodyStyles: { fontSize: 9 },
      columnStyles: {
        0: { cellWidth: 'auto' },
        1: { halign: 'center', cellWidth: 20 },
        2: { halign: 'right', cellWidth: 28 },
        3: { halign: 'right', cellWidth: 28 }
      }
    });

    y = doc.lastAutoTable.finalY + 6;

    var subtotal = getSubtotal();
    var totalsX = pageWidth - margin;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('Subtotal:', totalsX - 40, y, { align: 'right' });
    doc.text(money(subtotal), totalsX, y, { align: 'right' });
    y += 5;

    if (state.shippingRate) {
      doc.text('Shipping (' + state.shippingRate.name + '):', totalsX - 40, y, { align: 'right' });
      doc.text('$' + parseFloat(state.shippingRate.price).toFixed(2), totalsX, y, { align: 'right' });
      y += 5;
    }

    doc.setDrawColor(200, 200, 200);
    doc.line(totalsX - 80, y - 1, totalsX, y - 1);
    y += 3;

    var shippingCents = state.shippingRate ? Math.round(parseFloat(state.shippingRate.price) * 100) : 0;
    var total = subtotal + shippingCents;
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(isInvoice ? 'Total Due:' : 'Estimated Total:', totalsX - 40, y, { align: 'right' });
    doc.text(money(total), totalsX, y, { align: 'right' });
    y += 10;

    /* -- Banking details (invoice mode only) -- */
    if (isInvoice) {
      if (y > doc.internal.pageSize.getHeight() - 90) {
        doc.addPage();
        y = margin;
      }

      doc.setDrawColor(200, 200, 200);
      doc.line(margin, y, pageWidth - margin, y);
      y += 8;

      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(26, 59, 74);
      doc.text('Wire Transfer Payment Details', margin, y);
      y += 6;

      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(0, 0, 0);

      var col1X = margin;
      var col2X = margin + 90;

      doc.setFont('helvetica', 'bold');
      doc.text('For payments in US Dollars:', col1X, y);
      doc.text('For payments in foreign currency:', col2X, y);
      y += 5;

      doc.setFont('helvetica', 'normal');
      doc.text('SWIFT: BOFAUS3N', col1X, y);
      doc.text('SWIFT: BOFAUS6S', col2X, y);
      y += 4;
      doc.text('ABA / Routing: 026009593', col1X, y);
      y += 4;
      doc.text('Bank of America, NA', col1X, y);
      doc.text('Bank of America, NA', col2X, y - 4);
      y += 4;
      doc.text('222 Broadway', col1X, y);
      doc.text('555 California St', col2X, y - 4);
      y += 4;
      doc.text('New York, NY 10038', col1X, y);
      doc.text('San Francisco, CA 94104', col2X, y - 4);
      y += 8;

      doc.setFont('helvetica', 'bold');
      doc.text('Beneficiary:', margin, y);
      y += 5;
      doc.setFont('helvetica', 'normal');
      doc.text('World Possible', margin, y); y += 4;
      doc.text('4482 Barranca Pkwy Ste 118', margin, y); y += 4;
      doc.text('Irvine, CA 92604', margin, y); y += 5;
      doc.setFont('helvetica', 'bold');
      doc.text('Account Number: 3251 3084 8147', margin, y);
      doc.setFont('helvetica', 'normal');
      y += 6;

      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);
      doc.text('The United States does not participate in IBAN. No IBAN number is required.', margin, y);
      doc.setTextColor(0, 0, 0);
      y += 8;
    }

    var notes = els.notes.value.trim();
    if (notes) {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Notes:', margin, y);
      y += 5;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      var splitNotes = doc.splitTextToSize(notes, pageWidth - margin * 2);
      doc.text(splitNotes, margin, y);
      y += splitNotes.length * 4 + 6;
    }

    if (SETTINGS.quoteTerms) {
      if (y > doc.internal.pageSize.getHeight() - 40) {
        doc.addPage();
        y = margin;
      }
      doc.setFontSize(8);
      doc.setFont('helvetica', 'italic');
      doc.setTextColor(120, 120, 120);
      var splitTerms = doc.splitTextToSize(SETTINGS.quoteTerms, pageWidth - margin * 2);
      doc.text(splitTerms, margin, y);
      doc.setTextColor(0, 0, 0);
    }

    var pageCount = doc.internal.getNumberOfPages();
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(150, 150, 150);
      doc.text(
        SETTINGS.companyName + ' | ' + docLabel + ' ' + quoteNum + ' | Page ' + i + ' of ' + pageCount,
        pageWidth / 2,
        doc.internal.pageSize.getHeight() - 8,
        { align: 'center' }
      );
      doc.setTextColor(0, 0, 0);
    }

    var filename = quoteNum + '.pdf';
    doc.save(filename);

    var custEmailVal = els.custEmail.value.trim();
    var pdfBase64 = doc.output('datauristring').split(',')[1];

    var payload = {
      quoteNumber: quoteNum,
      customerName: els.custName.value.trim(),
      customerEmail: custEmailVal,
      customerPhone: els.custPhone.value.trim(),
      customerAddress: els.custAddress.value.trim(),
      language: state.language,
      deploymentCountry: els.custCountry ? els.custCountry.value.trim() : '',
      items: getItems().map(function (item) {
        return {
          title: item.title,
          variantTitle: '',
          qty: item.qty,
          unitPrice: money(item.price),
          lineTotal: money(item.price * item.qty)
        };
      }),
      subtotal: money(subtotal),
      shipping: state.shippingRate ? {
        name: state.shippingRate.name,
        price: '$' + parseFloat(state.shippingRate.price).toFixed(2)
      } : null,
      total: money(subtotal + shippingCents),
      notes: els.notes.value.trim(),
      pdfBase64: custEmailVal ? pdfBase64 : ''
    };

    els.downloadBtn.textContent = custEmailVal ? 'Sending email...' : 'Saving ' + (isInvoice ? 'invoice' : 'quote') + '...';

    fetch('https://datapost.site/api/send-quote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.success) {
        els.downloadBtn.textContent = custEmailVal
          ? docLabel + ' ' + quoteNum + ' sent to ' + custEmailVal + '!'
          : docLabel + ' ' + quoteNum + ' saved!';
        setTimeout(function () {
          els.downloadBtn.textContent = isInvoice ? 'Download & Email Invoice' : 'Download & Email Quote';
          els.downloadBtn.disabled = false;
        }, 4000);
      } else {
        throw new Error(data.error || 'Save failed');
      }
    })
    .catch(function (err) {
      els.downloadBtn.textContent = isInvoice ? 'Download & Email Invoice' : 'Download & Email Quote';
      els.downloadBtn.disabled = false;
      if (custEmailVal) {
        alert('Quote downloaded but email failed: ' + err.message);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Event Bindings                                                     */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('.quote-catalog__qty').forEach(function (input) {
    input.addEventListener('focus', function () {
      if (input.value === '0') { input.value = ''; }
    });
    input.addEventListener('blur', function () {
      if (input.value === '') { input.value = '0'; }
    });
    input.addEventListener('change', function () {
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) { input.value = 0; }
      renderItems();
    });
    input.addEventListener('input', function () {
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) { input.value = ''; }
      renderItems();
    });
  });

  els.getShippingBtn.addEventListener('click', fetchShippingRates);
  els.downloadBtn.addEventListener('click', generatePDF);

  // Update button text for invoice mode
  if (state.invoiceMode) {
    els.downloadBtn.textContent = 'Download & Email Invoice';
    var titleEl = document.getElementById('quoteBuilderTitle');
    if (titleEl) titleEl.textContent = 'Create Invoice';
  }

  // Language selector
  document.querySelectorAll('.quote-catalog__lang-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.quote-catalog__lang-btn').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.language = btn.getAttribute('data-lang');
    });
  });

  // Preload company logo for PDF
  if (SETTINGS.companyLogo) {
    var _logoImg = new Image();
    _logoImg.crossOrigin = 'anonymous';
    _logoImg.onload = function () {
      var c = document.createElement('canvas');
      c.width = _logoImg.naturalWidth;
      c.height = _logoImg.naturalHeight;
      c.getContext('2d').drawImage(_logoImg, 0, 0);
      state.logoDataUrl = c.toDataURL('image/png');
      state.logoWidth = _logoImg.naturalWidth;
      state.logoHeight = _logoImg.naturalHeight;
    };
    _logoImg.src = SETTINGS.companyLogo;
  }

  /* ------------------------------------------------------------------ */
  /*  Prefill from existing quote (?edit=Q-XXXX)                         */
  /* ------------------------------------------------------------------ */
  (function prefillFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var editNum = params.get('edit');
    if (!editNum) return;

    // Title-to-catalog-key map
    var TITLE_TO_KEY = {};
    Object.keys(CATALOG).forEach(function (k) {
      TITLE_TO_KEY[CATALOG[k].title.toLowerCase()] = k;
    });

    var url = 'https://datapost.site/api/quote?token=wp-healthcheck-2026&q=' + encodeURIComponent(editNum);
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success || !data.quote) return;
        var q = data.quote;

        // Show a banner
        var banner = document.createElement('div');
        if (state.invoiceMode) {
          banner.style.cssText = 'background:#d4edda;border:1px solid #28a745;border-radius:8px;padding:0.75rem 1.25rem;margin-bottom:1.5rem;font-size:0.95rem;color:#155724;';
          banner.innerHTML = 'Creating <strong>invoice</strong> from quote <strong>' + editNum + '</strong> — banking details will be included in the PDF.';
        } else {
          banner.style.cssText = 'background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:0.75rem 1.25rem;margin-bottom:1.5rem;font-size:0.95rem;color:#856404;';
          var invoiceUrl = window.location.origin + window.location.pathname + '?edit=' + editNum + '&invoice=true';
          banner.innerHTML = 'Editing quote <strong>' + editNum + '</strong> — make changes and generate a new PDF. <a href="' + invoiceUrl + '" style="color:#856404;font-weight:600;">Convert to Invoice &rarr;</a>';
        }
        var firstSection = document.querySelector('.quote-catalog, .quote-builder');
        if (firstSection) firstSection.parentNode.insertBefore(banner, firstSection);

        // Fill product quantities
        if (q.items && q.items.length) {
          q.items.forEach(function (item) {
            var title = (item.title || item.name || '').toLowerCase();
            var key = TITLE_TO_KEY[title];
            if (key) {
              var input = document.querySelector('.quote-catalog__qty[data-product-key="' + key + '"]');
              if (input) {
                input.value = item.qty || item.quantity || 1;
              }
            }
          });
        }

        // Fill customer info
        if (els.custName && q.customerName) els.custName.value = q.customerName;
        if (els.custEmail && q.customerEmail) els.custEmail.value = q.customerEmail;
        if (els.custPhone && q.customerPhone) els.custPhone.value = q.customerPhone;
        if (els.custAddress && q.customerAddress) els.custAddress.value = q.customerAddress;
        if (els.custCountry && q.deploymentCountry) els.custCountry.value = q.deploymentCountry;
        if (els.notes && q.notes) els.notes.value = q.notes;

        // Trigger items render
        renderItems();
      })
      .catch(function (err) {
        console.warn('Failed to load quote for editing:', err);
      });
  })();
})();
